import React, { FC, useState } from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '@hooks/redux-custom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const SuccessView: FC<Props> = ({ isOpen, onClose }) => {
  const [timer, setTimer] = useState(3);
  const history = useHistory();
  const customer = useAppSelector((state) => state.customer.value.selectedCustomer);

  const customerRedirect = () => {
    history.push(`/customer-detail/${customer?.id}#2`, { completeOrderRedirect: 'success' });
  };

  const orderSuccessCountdown = setInterval(() => {
    if (isOpen) {
      if (timer > 0) {
        setTimer(timer - 1);
      }

      if (!timer) {
        customerRedirect();
        clearInterval(orderSuccessCountdown);
        onClose();
      }
    }
  }, 1000);

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <Box display="flex" alignItems="center" flexDirection="row" px={2} pt={3} justifyContent="center">
        <CheckCircleIcon color="success" sx={{ fontSize: '40px' }} style={{ marginRight: '10px' }} />
        <Typography variant="h3">ORDER SUCCESSFUL</Typography>
      </Box>
      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <Typography variant="body1">You will be redirected to the customer page in</Typography>
          <Typography
            style={{
              fontSize: '75px',
              color: '#ddd',
            }}
          >
            {timer}
          </Typography>
          <Typography variant="body1">seconds.</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
